import React from 'react';
import { TabBox } from "./TabBox";
import { CalendarBox } from "./CalenderBox";
import { MealBox } from "./MealBox"
import "./release.less"
import { FoodModel } from './foodModel';
export function TakeMeal() {
    return (
        <>
            <TabBox />
            <div style={{ marginTop: "15px", display: "flex" }} className="takeMeal">
                <CalendarBox />
                <MealBox />
                <FoodModel/>
            </div>
        </>
    );
}


